import { PendingCardToken } from '@eika-infrastruktur/mobilbank-lib/src/nativeProps';

import { PendingCardStatus, PendingCardTokenActionResult, PendingCardTokenItem } from '@/domain/digital-wallet';

import { ActivationCardToken } from '@generated-types';

export const getStatusForCardToken = (
    item: PendingCardTokenItem,
    statusArray: PendingCardStatus[],
): PendingCardTokenActionResult | undefined =>
    statusArray.find((status) => status.tokenId === (item.source === 'te' ? item.token.eikaTokenId : item.token.id))
        ?.status;

export const getStatusForCardTokenUI = (
    pendingCard: { tokenId: string },
    statusArray: PendingCardStatus[],
): PendingCardTokenActionResult | undefined =>
    statusArray.find((status) => status.tokenId === pendingCard.tokenId)?.status;

export const getPendingCardTokensForDevice = <T extends ActivationCardToken>(
    pendingCardTokens: T[],
    nativeCardTokens: PendingCardToken[] = [],
): ActivationCardToken[] =>
    pendingCardTokens.filter((pendingCard) =>
        nativeCardTokens.some(
            (nativeToken) =>
                nativeToken.primaryAccountIdentifier.value === pendingCard.panUniqueReference &&
                nativeToken.tokenUniqueReference.value === pendingCard.tokenUniqueReference,
        ),
    );
